module.exports = "<iframe src = \"https://ops-preprod.fracpro.ai/logout\" frameborder=\"0\"></iframe>"